<template>
    <div class="page">
        <div class="page_header">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>集团/上市公司网站制作</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="page_headerSecondary">
            <div>
                <VyAddBtn @click.native="openAdd()" />
            </div>
            <div></div>
        </div>
        <!-- 列表 -->
        <div class="page_content">
            <el-table :data="tableData" @row-click="handleRowClick" row-key="id" border ref="tab">
                <el-table-column prop="title" align="center" label="标题"></el-table-column>
                <el-table-column prop="status" align="center" label="状态">
                    <template slot-scope="{ row }">
                        <span :style="{ color: row.status ? '#b66dff' : '#fe7c96' }">{{ row.status ? "显示" : "隐藏" }}</span>
                    </template>
                </el-table-column>
                <!-- <el-table-column prop="answer" align="center" label="问题"></el-table-column> -->
                <!-- <el-table-column prop="ask" align="center" label="答案"></el-table-column> -->
                <el-table-column align="center" label="操作">
                    <template slot-scope="{ row }">
                        <div class="_add" v-if="row.pid == 0">
                            <button @click="openAdd(row)">添加</button>
                        </div>
                        <div class="_operate">
                            <button @click="openSet(row)">编辑</button>
                        </div>
                        <div class="_delete">
                            <button @click="del(row)">删除</button>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
        </div>

        <el-dialog
            :title="form.id ? '编辑' : '添加'"
            :visible.sync="dialogStatus"
            width="50%"
            :show-close="false"
            :before-close="bfc"
        >
            <el-form label-width="90px">
                <el-form-item label="标题">
                    <el-input v-model.trim="form.title"></el-input>
                </el-form-item>
                <el-form-item label="状态">
                    <el-switch
                        class="sw"
                        v-model="form.status"
                        active-color="#7781f1"
                        inactive-color="#ff4949"
                        active-text="显示"
                        inactive-text="隐藏"
                        :active-value="1"
                        :inactive-value="0"
                    ></el-switch>
                </el-form-item>
                <el-form-item label="图片" v-if="form.pid != 0">
                    <upload-img :src="form.image" @removeSrc="form.image = ''" ref="image"></upload-img>
                </el-form-item>
                <el-form-item label="详情" v-if="form.pid != 0">
                    <el-input type="textarea" autosize resize="none" v-model.trim="form.details"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogStatus = false">取 消</el-button>
                <el-button type="primary" @click="yes">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import axios from "axios";
import QueryString from "qs";
import VyAddBtn from "@/components/customs/VyAddBtn.vue";
import UploadImg from "@/components/customs/uploadImg.vue";
export default {
    components: { VyAddBtn, UploadImg },
    data() {
        return {
            tableData: [],
            dialogStatus: false,
            form: {},
        };
    },
    async created() {
        this.tableData = await this.getData();
    },
    methods: {
        async getData() {
            let { data } = await axios.get("/api/group/list");
            return data;
        },
        openAdd(row) {
            if (row) {
                // 添加二级
                this.form = {
                    title: "",
                    pid: row.id,
                    status: 0,
                    image: "",
                    details: "",
                };
            } else {
                // 添加一级
                this.form = {
                    title: "",
                    pid: 0,
                    status: 0,
                };
            }

            this.dialogStatus = true;
        },
        openSet(row) {
            this.form = { ...row };
            this.dialogStatus = true;
        },
        async yes() {
            let { form } = this;
            form.image = this.$refs.image.url;
            if (form.id) {
                // 编辑
                var { data } = await axios.put("/api/group/update", QueryString.stringify(form));
            } else {
                // 添加
                var { data } = await axios.post("/api/group/add", QueryString.stringify(form));
            }
            this.$message({
                type: data.code == 200 ? "success" : "error",
                message: data.msg,
            });
            this.dialogStatus = false;
            this.tableData = await this.getData();
        },
        async del({ id }) {
            let s = await this.$confirm("是否确认删除?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => true)
                .catch(() => false);
            if (!s) return;
            let { data } = await axios.delete("/api/group/delete", { params: { id } });
            this.$message({
                type: data.code == 200 ? "success" : "error",
                message: data.msg,
            });
            this.tableData = await this.getData();
        },
        // 点击行
        handleRowClick(row, column, event) {
            if (event.target.tagName === "BUTTON") return;
            this.$refs["tab"].toggleRowExpansion(row);
        },
    },
};
</script>

<style lang="less" scoped>
.page {
    .page_content {
        margin-top: 20px;
        .el-table {
            border-radius: 20px;
        }
    }
    .page_pagination {
        display: flex;
        justify-content: space-between;
        margin-top: 20px;
        /deep/.el-pagination {
            border-radius: 50px;
            overflow: hidden;
            padding: 0px;
        }
    }
    .page_headerSecondary {
        margin-top: 20px;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
}
.sw {
    /deep/.el-switch__label.is-active {
        color: #7781f1 !important;
    }
}
</style>
